import React from 'react';
import { hide as hideAction } from '../../_flux/actions/voucher_code_light_box_actions';
import { clickOnRedeem, close } from '../../_modules/google_analytics/voucher_code_light_box';
import { handleView } from '../handle_view';
import { VoucherCodeLightBoxStore } from '../../_flux/stores/voucher_code_light_box_store';
import { VoucherCodeLightBox } from '../../_flux/components/voucher_code_light_box/voucher_code_light_box';

const stores = {
    voucherCodeLightBox: VoucherCodeLightBoxStore,
};

function render(
    {
        voucherCodeLightBox,
    },
    options
) {
    const { visible, expanded, loading } = voucherCodeLightBox;
    
    return (
        <VoucherCodeLightBox
            code={voucherCodeLightBox.code}
            visible={visible}
            loading={loading}
            expanded={expanded}
            data={voucherCodeLightBox.obj}
            error={{ ...voucherCodeLightBox }}
            onClose={onClose}
            onRedeem={options.onRedeem}
        />
    );
}

const getOptions = options => ({
    ...options,
    onRedeem: onRedeemFactory(options.onRedeem),
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);

export const onClose = () => {
    close();
    
    if (!TYROOLA.page.$container.hasClass('product') && stores.voucherCodeLightBox._state.valid) {
        hideAction();
        location.reload();
    }
    hideAction();
};

const onRedeemFactory = (onRedeem) => (obj, checkValidity, recaptchaToken) => {
    onRedeem(obj, null, recaptchaToken);
    clickOnRedeem(obj);
};
